module.exports = __webpack_public_path__ + "media/images/hora-f401a6155f4585eeb52372816812c522.png";